import { LoaderDisplay } from '../Components/LoaderDisplay';
import {cDisplay} from '../creator/cDisplay'
import { infoBubble } from "../creator/cDisplayObjects/infoBubble";
import { cGame } from '../creator/cGame';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cTextSprite } from '../creator/cGameObjects/cTextSprite';
import { helper } from '../creator/cGameObjects/helper';
import {cScene} from '../creator/cScene'
import { logging } from "../creator/utils/logging";


export class interfaceDisplay extends cDisplay {

  private _debugRect: Phaser.GameObjects.Graphics;
  private loader: LoaderDisplay;
  private task: IconPopup

  private logoYY: number

  private all_buttons: any
  private mod_buttons: any

  init(){
    super.init();

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
    })

    this._debugRect = new Phaser.GameObjects.Graphics(this.scene) //  this.ref.add.graphics();
    this.scene.add.existing(this._debugRect)

    this.scene.sys.scale.on('resize',(gameSize, baseSize, displaySize, resolution)=>{
      this.handleResize();
    });

    this.scene.events.on('resize', ()=>{
      this.handleResize();
    });

    this.visible = true
  }


  handleResize(){
    var l = this.getByName('holder_left')
    var r = this.getByName('holder_right')
    var rect = helper.getDisplayRect(this.scene as cScene);
    l.x = rect.left;
    r.x = rect.left + rect.width;
  }

  buildScene(){    
    super.buildScene();     
    this.handleResize();

    var backPack = new IconPopup( this.getByName('btn_suitcase'),this.getByName('btn_suitcase_label'),150,()=>{
      (this.scene as cScene).triggerSceneEvent('backpack');
    })

    var book = new IconPopup( this.getByName('btn_book'),this.getByName('btn_book_label'),180,()=>{
      (this.scene as cScene).triggerSceneEvent('book');
    })

    var plan = new IconPopup( this.getByName('btn_ticket'),this.getByName('btn_ticket_label'),150,()=>{
      (this.scene as cScene).triggerSceneEvent('ticket');
    })

    this.task = new IconPopup( this.getByName('btn_checklist'), this.getByName('btn_checklist_label'),180,()=>{
      (this.scene as cScene).triggerSceneEvent('task');
    }); 

    this.all_buttons = [backPack,book,plan,this.task]
    this.mod_buttons = {
      'mod_0':[],
      'mod_1':[backPack,book,plan],
      'mod_2':[backPack,book,this.task]      
    }

    setTimeout(()=>{
      this.showInitialInterface();
    },500)
  }

  private showInitialInterface(){
    this.show(true);
    this.showNavigation(false);
    (this.scene.game).scene.bringToTop('_global')
  }

  public show(opt:boolean){
    this.visible = opt
    if (opt){
      var logo = this.getByName('logo_top');      
      if (logo){
        if (!this.logoYY) this.logoYY = logo.y
        logo.visible = true
        logo.y = this.logoYY - 100;
        this.scene.tweens.add({
          targets:[logo],
          y:this.logoYY,
          ease:'Sine.easeOut',
          duration:400
        })
      }
    }
  }


  /**
   * Show Navigation
   * @param opt 
   */
  public showNavigation(opt:boolean){
    this.show( opt )

    if (opt){
      var mod = cGame.current.state.get('module')
      var showList = this.mod_buttons['mod_'+mod]
      this.all_buttons.forEach( (el)=>el.visible=false );
      if (showList) showList.forEach( (el)=>el.visible=true );
    }

    var holder = this.getByName('holder_right');      
    if (holder){
      var yy = holder.y;
      holder.visible = true
      this.scene.tweens.add({
        targets:[holder],
        y: opt ? 1080 : 1080 +150,
        ease:'Sine.easeOut',
        duration:400
      });
    }
  }


  /**
   * Show loader
   * @param opt 
   */
  public loadShow(opt:boolean){    
    if (opt && this.loader){
      this.remove(this.loader);
      this.loader.destroy();
      this.loader = null;
    }

    if (!opt && this.loader){
      this.loader.close()
    }else if(opt && !this.loader){

      this.loader = new LoaderDisplay(this.scene);
      this.scene.add.existing(this.loader);
      this.add(this.loader);
      this.bringToTop(this.loader);
    }
  }

  public loadProgress(val:number){    
    this.bringToTop(this.loader);
    this.loader.progress = val
  }


  public handleAction(action,opt){
    logging.log('NEW TASK',action,opt)

    switch (action){

      case 'new_task':
        cGame.current.state.set('2::currenttask',opt)
        if (opt){
          this.task.popup(true)
          this.task.doClick()
          setTimeout(()=>{
            this.task.popup(false)
          },3000)  
        }else{
          this.task.hide()
        }
        break;

      case 'hide_task':
        (this.scene as cScene).triggerSceneEvent('hide_task');
        break;

    }

  }


  private idd: any
  public startTimer(time,postOverlay){
    var tRef:cTextSprite = this.getByName('timer') as cTextSprite
    var countDown = time

    if (this.idd) clearInterval(this.idd);
    tRef.visible = true
    tRef.textdata = time
    this.idd = setInterval(()=>{
      countDown--
      tRef.textdata = ''+countDown

      if (countDown === 0){
        clearInterval(this.idd);
        tRef.visible = false
        cGame.current.setOverlay(postOverlay, {}, (res:any)=>{
        });
      }
    },1000)
    console.log('Start New Timer',time,postOverlay)
  }


  public clearHints(){
    var items = this.scene.children.getAll();
    items.forEach((el) => {
      if (el instanceof infoBubble) {
        el.close();
      }
    })

  }

}










/**
 * 
 */
class IconPopup {
  private yy: number
  private yy_label: number
  private yyDown: number = 230;
  private sc: cScene

  private ref: cSprite
  private reflabel: cTextSprite
  private cb:Function

  private tween1: any;
  private tween2: any;

  constructor(ref:cSprite,ref_label:cTextSprite,drop:number,cb:Function){

    this.cb = cb

    this.yy = ref.y;
    this.yy_label = ref_label.y;
    this.yyDown = drop
    this.sc = ref.scene as cScene
    this.ref = ref;
    this.reflabel = ref_label;
    
    this.ref.y = this.yyDown    
    this.reflabel.y = 200;
    this.ref.setInteractive({useHandCursor:true});
    this.ref.on('pointerover',()=>{    
      this.popup(true);
      this.sc.snd('sound_woosh')      
    });
    this.ref.on('pointerout',()=>{
      this.popup(false);
    });
    this.ref.on('pointerup',()=>{
      cb();
    });
  }


  doClick(){
    this.cb()
  }

  hide(){
    this.tween1 = this.sc.tweens.add({
      targets:[this.ref],
      y: 300,
      duration: 400,
      ease:'Back.easeOut'
    })
  }

  popup(opt){
    if (this.tween1) this.tween1.stop();
    if (this.tween2) this.tween2.stop();

    this.tween1 = this.sc.tweens.add({
      targets:[this.ref],
      y: opt ? this.yy : this.yyDown,
      duration: 400,
      ease:'Back.easeOut'
    })

    this.tween2 = this.sc.tweens.add({
      targets:[this.reflabel],
      y: opt ? this.yy_label : 100,
      duration: 200,
      delay: opt ? 100 : 0,
      ease:'Sine.easeOut'
    })
  }


  set visible(v:boolean){
    this.ref.visible = v
    this.reflabel.visible = v
  }

}